import * as yup from "yup";

/**
 * Validation schema for intake form questions
 * - Text fields (free_text): Must have non-empty string if required
 * - Single choice: Must have selected option if required
 * - Multiple choice: Must have at least one selected option if required
 * - File upload: Must have at least one file if required
 */
export const intakeFormValidationSchema = yup.object({
  questions: yup.array().of(
    yup.object({
      id: yup.string().required(),
      question_number: yup.number().required(),
      question: yup.string().required(),
      field_name: yup.string().required(),
      question_type: yup
        .string()
        .oneOf(["free_text", "single_choice", "multiple_choice", "file_upload"])
        .required(),
      required: yup.boolean().required(),
      is_dropdown: yup.boolean().required(),
      hidden_from_user: yup.boolean().required(),
      response_choices: yup.array().of(yup.string()).nullable(),
      max_number_of_files: yup.number().nullable(),
      source_urls: yup.array().of(yup.string()).nullable(),
      agent_session_id: yup.string().nullable(),
      response: yup.mixed().test(
        "required-field-validation",
        function (value) {
          const { required, question_type } = this.parent;

          // If not required, always pass
          if (!required) {
            return true;
          }

          // For free_text and single_choice, check if string is non-empty
          if (question_type === "free_text" || question_type === "single_choice") {
            if (typeof value !== "string" || value.trim().length === 0) {
              return this.createError({
                message: question_type === "free_text" ? "This field is required" : "Please select an option",
              });
            }
          }

          // For multiple_choice and file_upload, check if array has items
          if (question_type === "multiple_choice" || question_type === "file_upload") {
            if (!Array.isArray(value) || value.length === 0) {
              return this.createError({
                message: question_type === "file_upload" ? "Please upload at least one file" : "Please select at least one option",
              });
            }
          }

          return true;
        }
      ),
    })
  ),
});
